import {
  DEFAULT_SPLIT_SIZE_DAG,
  DEFAULT_SPLIT_SIZE_TIMELINE,
  DEFAULT_SPLIT_SIZE_NONE,
  GRAPH_VIEW_DAG,
  GRAPH_VIEW_TIMELINE,
} from "./constants";

export const getDefaultSplitSize = ({ graphView }) => {
  switch (graphView) {
    case GRAPH_VIEW_DAG:
      return DEFAULT_SPLIT_SIZE_DAG;
    case GRAPH_VIEW_TIMELINE:
      return DEFAULT_SPLIT_SIZE_TIMELINE;
    default:
      return DEFAULT_SPLIT_SIZE_NONE;
  }
};
